/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Property_Sub_StructureInputs */

const cs_property_sub_structure = /** @type {(inputs: Property_Sub_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Podlaží a roky`)
};

const en_property_sub_structure = /** @type {(inputs: Property_Sub_StructureInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Floors & years`)
};

/**
* | output |
* | --- |
* | "Floors & years" |
*
* @param {Property_Sub_StructureInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_sub_structure = /** @type {((inputs?: Property_Sub_StructureInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Sub_StructureInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_sub_structure(inputs)
	return cs_property_sub_structure(inputs)
});